<div [ngClass]="theme()" class="py-2">
  <div mat-dialog-title class="p-0 border-bottom">
    <div class="d-flex align-items-center py-2 px-3" [class.justify-content-between]="options.closable !== false">
      <span class="text-primary font-weight-bold">{{ options.title | translate }}</span>

    @if (options.closable !== false) {
      <lib-button (buttonClicked)="cancel()" color="primary-link" fontSize="18px" faIcon="far fa-times" size="custom"> </lib-button>
    }
  </div>
  </div>

  <div [style.height.px]="options.dialogHeight ?? 300" style="width: 100%" class="px-3 align-content-center d-flex flex-column">
    <div class="text-primary p-3 my-auto d-flex flex-column align-items-center">
      <span class="text-center" [innerHTML]="options.message | translate: options.messageParams"></span>

      <div class="mt-3">
        @if (options.centerButtons) {
          <lib-button class="mr-2" [color]="'secondary'" [size]="'medium'" [label]="options.cancelButtonText | translate" (buttonClicked)="cancel()">
          </lib-button>
          <lib-button class="mr-2" [size]="'medium'" [label]="options.confirmButtonText | translate" (buttonClicked)="confirm()"> </lib-button>
        }
      </div>
    </div>
  </div>

  @if (!options.centerButtons) {
    <div class="d-flex border-top pb-2 pt-3 px-3" [ngClass]="options.centerButtons ? 'justify-content-center' : 'justify-content-end'">
      <lib-button class="mr-2" [color]="'secondary'" [size]="'medium'" [label]="options.cancelButtonText | translate" (buttonClicked)="cancel()"> </lib-button>
      <lib-button class="mr-2" [size]="'medium'" [label]="options.confirmButtonText | translate" (buttonClicked)="confirm()"> </lib-button>
    </div>
  }
</div>
